"use strict";
exports.__esModule = true;
function executeInSeries(callbacks, args, context, done) {
    var length = args.length;
    var callbacksCopy = callbacks.slice();
    function iterator(itCallbacks, subArgs) {
        if (!itCallbacks.length) {
            return typeof done === "function" ? done() : true;
        }
        var callback = itCallbacks.shift();
        if (!callback) {
            throw new Error("Callback not found");
        }
        callback.apply(context, subArgs);
        if (callback.length === length) {
            iterator(itCallbacks, subArgs);
        }
    }
    args.push(function () { return iterator(callbacksCopy, args); });
    iterator(callbacksCopy, args);
}
exports.executeInSeries = executeInSeries;
